export default __webpack_public_path__ + "static/media/FOTO-10.98092d67.jpg";